<template>
    <div class="item px-2 py-1 fs-3 cpointer">
        <div class="item-module flex-level px-2" @click="toggleList">
            <h4 class="m-0">{{ data.title }}</h4>
            <span class="ml-2 gray-60">{{ data.total }}</span>
            
            <span class="flex-item-right primary-50" >
                <i :class="displayList == false ? 'icon-caret-down-fillout' : 'icon-caret-top-fillout'" />
            </span>
        </div>


        <ul class="mb-0 ml-3" v-if="displayList">
            <li class="mt-2 px-2 py-1 br hover-primary-05-bkg" v-for="(row, index) in data.data" v-bind:key="index">
                <a class="flex-level cpointer" :href="row.url">
                    <span class="gray-100">
                        {{ row.label }}
                    </span>
                    <span class="ml-2 gray-60">
                        {{ row.value }}
                    </span>
                    <i class="icon-arrow-back dinlineb rotated-180 flex-item-right gray-60 fs-4" />
                </a>
            </li>
        </ul>

    </div>
</template>

<script>
    export default{
        props: {
            data: {
                type: Object,
                required: true
            }
        },
        data(){
            return {
                displayList: false,
            }
        },
        methods: {
             toggleList () {
                this.displayList = !this.displayList;
			}
        }
    }
</script>

<style lang='scss' scoped>

    @import '~@sellsy/styleguide/src/_variables';

    .item {
        .item-module {
            min-height  : 16px;
        }
    }
</style>